export default [
  '$1 - $1M',
  '$1M - $5M',
  '$5M - $10M',
  '$10M - $25M',
  '$25M - $50M',
  '$50M - $100M',
  '$100M - $250M',
  '$250M - $500M',
  '$500M - $1B',
  '$1B - $2.5B',
  '$2.5B - $5B',
  'Over $5B',
]



// WEBPACK FOOTER //
// ./src/scripts/constants/DemandbaseRevenueRanges.js